var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E92191D-A76E-49AB-B6AF-347F1331A4DC@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-955.000000, -2582.000000)",
    stroke: "#145685",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/24px/plus",
    transform: "translate(955.000000, 2582.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 11,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(6.000000, 6.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -4.04088527e-17,
    y1: 5,
    x2: 10,
    y2: 5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.46944695e-15,
    y1: 5,
    x2: 10,
    y2: 5,
    id: "Path",
    transform: "translate(5.000000, 5.000000) rotate(-270.000000) translate(-5.000000, -5.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default __webpack_public_path__ + "static/media/plus-round.81d2b77dd6959a5b8beacfa8d00dad9e.svg";
export { ForwardRef as ReactComponent };